import axios, { AxiosError } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';

export interface GeoLocationData {
  country_code: string | null;
  country_name: string | null;
  city?: string | null;
  postal?: string | null;
  latitude: number | null;
  longitude: number | null;
  IPv4: string | null;
  state?: string | null;
}

type GeolocationResult = GeoLocationData | { IPv4: string };

const fetchIpAddress = async (): Promise<{ IPv4: string }> => {
  try {
    const { data } = await axios.get<{ ip: string }>(
      'https://api.ipify.org/?format=json',
    );
    return { IPv4: data.ip };
  } catch (error) {
    console.error('Error fetching IP address:', error);
    return { IPv4: '127.0.0.1' };
  }
};

export const useGeolocationQuery = (): UseQueryResult<
  GeolocationResult,
  AxiosError
> => {
  return useQuery<GeolocationResult, AxiosError>(
    ['GeolocationQuery'],
    async () => {
      try {
        const { data } = await axios.get<GeoLocationData>(
          'https://geolocation-db.com/json/',
        );
        if (!data || !data.IPv4 || data.IPv4 === 'Not found') {
          // fallback if no data is returned
          return fetchIpAddress();
        }
        return data;
      } catch (error) {
        console.error('Error fetching geolocation data:', error);
        // also fallback if error is thrown from 1st request
        return fetchIpAddress();
      }
    },
  );
};
